import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AdressePhysiqueBancaire } from 'src/app/api/model/adresse-physique-bancaire.model';
import { FormulaireCoordonneesBancaires } from 'src/app/models/formulaire/formulaire-coordonnees-bancaires.model';
import { ChangementCoordonneeBancaireAccesDService } from 'src/app/services/changement-coordonnee-bancaire-accesd/changement-coordonnee-bancaire-acces-d.service';
import { FormulaireBancaireService } from 'src/app/services/formulaire-bancaire/formulaire-bancaire.service';
import { GabaritService } from 'src/app/services/gabarit/gabarit.service';
import { GestionErreurService } from 'src/app/services/gestion-erreur/gestion-erreur.service';
import { GlobalStoreService } from 'src/app/services/global-store/global-store.service';
import { GestionTitreService } from 'src/app/services/navigation/gestion-titre.service';
import { NavigationService } from 'src/app/services/navigation/navigation.service';
import { RequeteCoordonneesBancaireService } from 'src/app/services/requete-coordonnees-bancaire/requete-coordonnees-bancaire.service';
import { DateUtil } from 'src/app/util/date-util';

@Component({
  selector: 'app-page-validation',
  templateUrl: './page-validation.component.html',
  styleUrls: ['./page-validation.component.scss'],
  standalone: false,
})
export class PageValidationComponent implements OnInit {
  isAppMobile: boolean;
  form: FormGroup<FormulaireCoordonneesBancaires>;
  codeErreur: string = '';
  adresseSaisie: AdressePhysiqueBancaire;
  dateChangement: string;
  dateUtil = new DateUtil();

  constructor(
    private readonly gabaritService: GabaritService,
    private readonly gestionTitreService: GestionTitreService,
    private readonly navigationService: NavigationService,
    private readonly globalStoreService: GlobalStoreService,
    private readonly formulaireBancaireService: FormulaireBancaireService,
    private readonly gestionErreurService: GestionErreurService,
    private readonly requeteCoordonneesBancaireService: RequeteCoordonneesBancaireService,
    private readonly coordonneesBancaireService: ChangementCoordonneeBancaireAccesDService
  ) {}

  ngOnInit(): void {
    this.isAppMobile = this.gabaritService.isAppMobile();
    this.gestionTitreService.addTitreOnglet('caad.titreOnglet.page-validation');
    this.form = this.formulaireBancaireService.getForm();
    this.initAdresseSaisie();
    this.dateChangement = this.form.value.dateChangement ?? '';
  }

  get courriel(): string {
    return this.form?.value.courriel ?? '';
  }

  private initAdresseSaisie(): void {
    if (this.form.value.utiliserMemeAdresse) {
      this.globalStoreService.getCoordonneesMembre$().subscribe((adresse) => {
        this.adresseSaisie = adresse?.adresseCourante ?? null;
      });
    } else {
      this.adresseSaisie = this.getAdresseSaisie();
    }
  }

  private getAdresseSaisie(): AdressePhysiqueBancaire {
    return {
      numeroCivique: this.form.value.numeroCivique ?? '',
      nomRue: this.form.value.rue ?? '',
      numeroUnite: this.form.value.appartement ?? '',
      nomMunicipalite: this.form.value.ville ?? '',
      codeSubdivisionPays: this.form.value.province ?? '',
      codePostal: this.form.value.codePostal ?? '',
      codePays: this.form.value.codePays ?? '',
      numeroCiviqueNomRue: `${this.form.value.numeroCivique ?? ''} ${this.form.value.rue ?? ''}`,
    } as AdressePhysiqueBancaire;
  }

  naviguerVersModifier(): void {
    this.navigationService.naviguerVersModifierCoordonnees();
  }

  naviguerVersConfirmation(): void {
    this.coordonneesBancaireService
      .modifierCoordonnees$(this.requeteCoordonneesBancaireService.construireRequeteModifierCoordonnees())
      .subscribe({
        next: () => {
          this.navigationService.naviguerVersCoordonneesConfirmation();
        },
        error: (err: HttpErrorResponse) => {
          this.codeErreur = this.gestionErreurService.getCodeErreur(err);
          this.navigationService.naviguerVersPageErreurCoordonnees(
            err.status.toString(),
            this.codeErreur,
            this.gestionErreurService.getMessageErreur(err)
          );
        },
      });
  }

  get afficherDateChangement(): boolean {
    //Nous n'utilisons pas parse ici, car le parsing avec le format sans heure est toujours interprétée en UTC
    //ce qui pourrait potentiellement causer un décalage d’un jour selon le fuseau horaire du membre.
    if (!this.dateChangement) return false;
    const aujourdHui = new Date();
    const [year, month, day] = this.dateChangement.split('-').map(Number);
    const datePostdatee = new Date(year, month - 1, day);

    return datePostdatee > aujourdHui;
  }

  get libelleAdresse(): string {
    return this.dateUtil.estMemeJour(this.dateChangement)
      ? 'caad.page-validation.coordonnees.adresse'
      : 'caad.page-validation.coordonnees.nouvelleAdresse';
  }

  annuler(): void {
    this.globalStoreService.saveEtatAfficherModaleAnnuler(true);
  }
}
